var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkIfIsBecomeDomain())?_c('bounce-loader'):(_vm.isLoaderV1)?_c('pulse-loader'):_c('pulse-loader-v2')
}
var staticRenderFns = []

export { render, staticRenderFns }